import React, { useState, useEffect } from 'react';
import UploadMultiDocuments from '@components/UploadMultiDocuments';
import { FileListData } from '@typings/ResidentTypes';
import UploadedFileTable from '@components/UploadedFileTable';

interface UploadCprDocumentProps {
  userId: string;
  uploadedCprDocumentList: FileListData[];
  setUploadedCprDocumentList: React.Dispatch<
    React.SetStateAction<FileListData[]>
  >;
}

const UploadCprDocument: React.FC<UploadCprDocumentProps> = ({
  userId,
  uploadedCprDocumentList,
  setUploadedCprDocumentList,
}) => {
  return (
    <div className="govuk-form-group mt-10 govuk-bp:mt-14">
      <h3 className="mb-5">
        <label
          className="govuk-label govuk-label--s"
          htmlFor="upload-assessment"
        >
          Upload a copy of the Cardio-Pulmonary Resuscitation (CPR) decision
        </label>
      </h3>
      <UploadMultiDocuments
        userId={userId}
        fileList={uploadedCprDocumentList}
        setFileList={setUploadedCprDocumentList}
        uploadInputId="upload-mca-form"
        customizedButtonText="Upload CPR Document"
      />
      <div className="mt-10 govuk-bp:mt-14">
        {uploadedCprDocumentList?.length > 0 && (
          <UploadedFileTable
            headerTitle="CPR Decision File Name"
            fileList={uploadedCprDocumentList}
            setFileList={setUploadedCprDocumentList}
          />
        )}
      </div>
    </div>
  );
};

export default UploadCprDocument;
